// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/css-loader/index.js??ref--10-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--10-3!../../../../../node_modules/fast-sass-loader/lib/index.js??ref--10-4!./style.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("a0935f56", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/public/plugins/copy-cells/set-cell-style/style.scss
// module id = D07e
// module chunks = 6